import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from "react-router-dom";
// import { useQuery } from '@tanstack/react-query';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import '../App.css';
import { useAuth } from "../context/AuthContext";
import { useConfig } from '../context/ConfigContext';
import MorphUpload from "../components/MorphUpload";
import FavoriteButton from "../components/favoriteButton";
import LikeButton from "../components/likeButton";
import MorphModal from '../components/morphModal';

export const Morphs = () => {
    const { user, id, role } = useAuth();
    const { backendApiBaseUrl, isTesting } = useConfig();
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
    const [items, setItems] = useState([]);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [rightSideBarVisible, setRightSidebarVisible] = useState(false);
    const [selectedMorph, setSelectedMorph] = useState(null);
    const [cursor, setCursor] = useState(null);
    const colorOptions = [
        "black", "white", "red", "purple", "blue", "green",
        "brown", "pink", "orange", "yellow", "gray"
    ];
    const [hasMore, setHasMore] = useState(true);
    const [sortOrder, setSortOrder] = useState('Newest');
    const [searchParams, setSearchParams] = useSearchParams();
    const [pendingFilters, setPendingFilters] = useState({
        minFavorites: searchParams.get('minFavorites') || '',
        maxFavorites: searchParams.get('maxFavorites') || '',
        minLikeReact: searchParams.get('minLikeReact') || '',
        maxLikeReact: searchParams.get('maxLikeReact') || '',
        colors: searchParams.get('colors') ? searchParams.get('colors').split(',') : [],
        filterMode: searchParams.get('filterMode'),
        sort: searchParams.get('sort') || 'Newest',
    });
    const [appliedFilters, setAppliedFilters] = useState(() => {
        return Object.fromEntries(
            [...searchParams.entries()].filter(([key, value]) => value !== '')
        );
    });
    const [showInfo, setShowInfo] = useState(false);

    

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleFilterSidebarToggle = () => {
        setSidebarVisible(!sidebarVisible);
    };
    const handlerightSidebarToggle = () => {
        setRightSidebarVisible(!rightSideBarVisible);
    };

    const handleOpenModal = (morph) => {
        setSelectedMorph(morph);
    };

    const handleCloseModal = () => {
        setSelectedMorph(null);
    };

    const fetchData = useCallback(async (cursorId = null, filters = {}) => {
        try {
            const url = new URL(`${backendApiBaseUrl}/morphs`);
            
            if (cursorId) {
				url.searchParams.append("cursor", cursorId);
			}
            
			const cleanFilters = Object.fromEntries(
				Object.entries(filters).filter(([key, value]) => value !== undefined && value !== null && value !== "")
			);
            
            if (typeof cleanFilters.colors === "string") {
                cleanFilters.colors = cleanFilters.colors.split(",");
            }
			
			const response = await axios.post(url.toString(), {
				filters: cleanFilters,
				userId: id,
                cursor: cursorId
			});
            const { items: rawEvents, hasMore: moreAvailable, cursor: newCursor } = response.data;
            
			setCursor(newCursor);
			setHasMore(moreAvailable);

            const transformed = rawEvents
                .filter(item => item.new_morph !== null)
                .map(item => ({
                    ...item.new_morph,
                    actorUsername: item.actor?.username ?? "Unknown",
                    actorId: item.actorId,
                    eventId: item.id,
                    type: item.type,
                    card_code: item.new_morph.cardCode,
                    description: item.new_morph.description,
                    createdAt: item.createdAt,
                    likeCount: item.new_morph._count?.likes ?? 0,
                    favoriteCount: item.new_morph._count?.favorites ?? 0,
                    hasLiked: Array.isArray(item.new_morph.likes) && item.new_morph.likes.length > 0,
                    hasFavorited: Array.isArray(item.new_morph.favorites) && item.new_morph.favorites.length > 0,
                }));

            if (cursorId) {
                setItems(prev => {
                    const updated = [...prev, ...transformed];
                    return updated;
                });
            } else {
                setItems(transformed);
            }

        } catch (err) {
            if (isTesting) {
                console.error("Failed to fetch morphs", err);
            }
        }
    }, [backendApiBaseUrl, id, isTesting]);
    

    useEffect(() => {
        const sort = searchParams.get('sort') || 'Newest';
		const urlFilters = {
			minFavorites: searchParams.get("minFavorites") || '',
			maxFavorites: searchParams.get("maxFavorites") || '',
			minLikeReact: searchParams.get("minLikeReact") || '',
			maxLikeReact: searchParams.get("maxLikeReact") || '',
            colors: searchParams.get('colors') ? searchParams.get('colors').split(',') : [],
            filterMode: searchParams.get('filterMode') || 'Any',
            sort: sort
		};


        setSortOrder(sort);
		setPendingFilters(urlFilters);
        fetchData(null, urlFilters);
	}, [fetchData, searchParams]);


    const fetchMoreData = () => {
        if (!hasMore) {
			return;
		}
		
		if (cursor) {
			fetchData(cursor, appliedFilters);
		}
    };

    const handleSort = (value) => {
		setSortOrder(value);
        setPendingFilters((prev) => ({ ...prev, sort: value }));
		setSearchParams(prev => {
			const params = new URLSearchParams(prev);
			params.set("sort", value);
			return params;
		});
	};

	const handleFilterChange = (key, value) => {
		setPendingFilters(prev => ({ ...prev, [key]: value }));
	};


    const handleColorFilter = (color) => {
        setPendingFilters(prev => {
            const updatedColors = prev.colors.includes(color)
                ? prev.colors.filter(c => c !== color)
                : [...prev.colors, color];
            return { ...prev, colors: updatedColors };
        })
    };

    const handleFilterModeToggle = () => {
        setPendingFilters(prev => ({
            ...prev,
            filterMode: prev.filterMode === "Any" ? "All" : "Any"
        }));
    };

    const handleFilterSubmit = () => {
        const filtered = Object.fromEntries(
            Object.entries(pendingFilters).filter(([_, v]) => {
                if (Array.isArray(v)) return v.length > 0;
                return v !== '' && v !== null && v !== undefined;
            })
        );

        const params = new URLSearchParams();

        Object.entries(filtered).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                params.set(key, value.join(','));
            } else {
                params.set(key, value);
            }
        });

		setSearchParams(params);
		setAppliedFilters(filtered);

		setItems([]);
		setHasMore(true);
		setCursor(null);
	};

    useEffect(() => {
        if (appliedFilters) {
            fetchData(null, appliedFilters);
        }
    }, [appliedFilters, fetchData]);
    
    
    return (    
        <div className='container-fluid m-0 p-0'>
            <div>
                <div className="row">
                    <aside className={`col-12 col-md-3 sidebar ${sidebarVisible ? 'd-block' : 'd-none d-md-block'} p-3 rounded`}
                        style={{ 
                            maxWidth: sidebarVisible ? '100%': '215px',
                            backgroundColor: "#2b2d31",
                            transition: 'max-width 0.3 ease',
                            overflow: 'hidden',
                            marginTop: '8px'
                            }}
                    >
						<h4>Filters</h4>
						<div className="mb-4">
							<label className="form-label filter-title">Favorites</label>
							<div className="d-flex gap-2">
								<input type="number" className="form-control form-control-sm" placeholder="Min" min="0" value={pendingFilters.minFavorites || ''}
								onChange={(e) => handleFilterChange("minFavorites", e.target.value)} />

								<input type="number"className="form-control form-control-sm" placeholder="Max" min="0" value={pendingFilters.maxFavorites || ''}
								onChange={(e) => handleFilterChange("maxFavorites", e.target.value)} />
							</div>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Likes / Reactions</label>
							<div className="d-flex gap-2">
								<input type="number"  className="form-control form-control-sm" placeholder="Min" min="0" value={pendingFilters.minLikeReact || ''}
								onChange={(e) => handleFilterChange("minLikeReact", e.target.value)}/>
								
								<input type="number" className="form-control form-control-sm" placeholder="Max" min="0" value={pendingFilters.maxLikeReact || ''}
								onChange={(e) => handleFilterChange("maxLikeReact", e.target.value)}/>
							</div>
						</div>

                        <form className='filterForm mb-5'>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => handleFilterModeToggle()}
                                type="button"
                                style={{ marginBottom: "20px" }}
                            >
                                Include: {pendingFilters.filterMode}
                            </button>

                            <div 
                                className="form-label"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseColors"
                                aria-expanded="true"
                                aria-controls="collapseColors"
                                style={{cursor: 'pointer'}}
                            >
                                <label style={{cursor: 'pointer'}}>
                                    Colors  ▼
                                </label>
                            </div>
                            <div className="collapse" id="collapseColors">
                                {colorOptions.map(color => (
                                    <label key={color} style={{ display: 'block', paddingLeft: "10%", paddingRight: "10%" }}>
                                    <div className='filterItemWrapper'>
                                        <input
                                        className='filterItem'
                                        onChange={() => handleColorFilter(color)}
                                        type="checkbox"
                                        id={color}
                                        name={color}
                                        value={color}
                                        />
                                        <label htmlFor={color}> {color.charAt(0).toUpperCase() + color.slice(1)}</label>
                                    </div>
                                    </label>
                                ))}
                            </div>
                        </form>

                        <button className="btn btn-primary mt-2" onClick={handleFilterSubmit}>
							Apply Filters
						</button>
                    </aside>

                    <div className='col-12 col-md-5' id="infiniteScrollContainer" style={{flexGrow: 1, padding: 0}}> 
                        <div className="d-flex justify-content-between align-items-center px-4 rounded">
							<div className='p-2'>
								<button 
									className="btn btn-secondary " 
									onClick={handleFilterSidebarToggle}
									style={{
										display: (!isMobile && !sidebarVisible) ? 'none' : 'block',
										background: '#2b2d31',
									}}>
									<i className="fa-solid fa-filter"></i>
								</button>
							</div>

							<div className='d-flex justify-content-end align-items-center'>
								<div className="p-2 ">
									<select className="form-select" value={sortOrder} style={{color:"black"}} onChange={(e) => handleSort(e.target.value)}>
										<option className='profile-filter-dropdown' value="Newest">Newest</option>
										<option className='profile-filter-dropdown' value="Oldest">Oldest</option>
									</select>
								</div>

                                {user && role !== 'BAND' && (
                                    <div className='d-none d-sm-block'>
                                        <button className={`upload-button btn btn-secondary ${rightSideBarVisible ?  "d-none": "d-block"}`} onClick={handlerightSidebarToggle}
                                            style={{
                                                background: '#2b2d31',
                                            }}>
                                            Upload
                                        </button>
                                    </div>
                                )}
							</div>
						</div>

                        {items.length === 0 ? (
                            <div className="text-center mt-4" style={{  color:"#FFF" }}>
                                No items found
                            </div>
                        ) : (
                            <InfiniteScroll
                                dataLength={items.length}
                                next={fetchMoreData}
                                hasMore={hasMore}
                                loader={<h4>Loading...</h4>}
                                scrollableTarget="infiniteScrollContainer"
                                className='itemScrollableArea'
                            >
                            {items.map(morph => (
                                <div key={morph.id} className="scroll-item" >
                                    <div className="image-container" >
                                        {Array.isArray(morph.images) && morph.images.length > 0 && (
                                        <img
                                            src={`${morph.images[0].presignedUrl}`}
                                            alt={morph.images[0].label}
                                            className=""
                                            style={{ maxWidth: '100%', paddingBottom: '10px', cursor: 'pointer' }}
											onClick={() => handleOpenModal(morph)}
                                        />
                                        )}
                                        <div className="card-body">
                                            <h5 className="card-title" >{morph.username.replaceAll('"', '')}</h5>

                                            <div className="mt-2" style={{  paddingBottom:"15px" }}>
                                                {morph.color_tags?.map((color, idx) => (
                                                <span key={idx} className="badge me-1" style={{ backgroundColor: color.trim() }}>{color.trim()}</span>
                                                ))}
                                            </div>
                                            
                                        </div>
                                        {role !== 'BAND' &&  (
                                            <div 
                                                style={{ display:"flex", width:"100%" }}
                                            >   
                                                <div
                                                    style={{ padding:"1%", marginRight:"20%", width:"100%"  }}
                                                >
                                                    <LikeButton 
                                                        itemType={morph.type}
                                                        itemId={morph.id} 
                                                        userId={id} 
                                                        hasLikedInitial={morph.hasLiked} 
                                                        likeCountInitial={morph.likeCount}
                                                    />
                                                </div>
                                                <div
                                                    style={{ padding:"1%", marginLeft:"20%", width:"100%"  }}
                                                >
                                                    <FavoriteButton 
                                                        itemType={morph.type}
                                                        itemId={morph.id}
                                                        userId={id}
                                                        hasFavoritedInitial={morph.hasFavorited}
                                                        favoriteCountInitial={morph.favoriteCount}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                            </InfiniteScroll>
                        )}
                        <MorphModal
                            selectedItem={selectedMorph}
                            show={selectedMorph !== null}
                            onClose={handleCloseModal}
                        />
                    
                        
                    </div>

                    {user && role !== 'BAND' &&  (
                        <aside className={`col-12 col-md-5 p-3 rounded user-sidebar ${rightSideBarVisible ? "d-block" : "d-none"}`}    
                        style={{ 
                            backgroundColor: "#2b2d31",
                            position: "relative",
                            maxWidth: rightSideBarVisible ? '300px' : '300px' }}
                        >
                            
                            <button className="btn-close" onClick={handlerightSidebarToggle} 
                                style={{ position: "absolute", top: "10px", right: "10px", transition: 'width 0.3s ease', overflow: 'hidden'}}></button>
                            
                            <div className=" gap-2 position-relative mx-2">
                                <h3 className="mb-0">Upload Morph</h3>

                                <i
                                    className="fa-solid fa-circle-info"
                                    style={{ cursor: "pointer" }}
                                    onMouseEnter={() => setShowInfo(true)}
                                    onMouseLeave={() => setShowInfo(false)}
                                />

                                {showInfo && (
                                    <div className="tooltip-box">
                                        Disclaimer*: You must own this morph. Check about page for info on what images you can upload, as well as what morphs risk deletion.
                                    </div>
                                )}
                            
                            
                                <MorphUpload
                                    fetchData={fetchData} 
                                />
                            </div>
                        </aside>
                    )}
                </div>
            </div>
        </div>
    );
}
